import { render, staticRenderFns } from "./ForYouUsers.vue?vue&type=template&id=6992e0bc&"
import script from "./ForYouUsers.vue?vue&type=script&lang=js&"
export * from "./ForYouUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports